import AjaxClass from './Validation/ajaxClass';
import ConversionPopup from './Validation/conversionPopup';
const SIMULATION_STEP_TWO_FORM_IDS = ['simulation-form-2', 'formulario-simulacao-unidade-etapa-2'];
export default function bootstrapForms() {
    const conversionPopup = new ConversionPopup();
    document.querySelectorAll('form.needs-validation').forEach(formElement => {
        if (formElement.classList.contains('custom')) {
            return false;
        }
        formElement.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
    
            let form = this;
            let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));
            let images = form.querySelectorAll('input[type=file]');
            if (images.length > 0) {
                images.forEach(e => {
                    let image = { name: e.name, value: e.files[0] };
                    fields.push(image);
                });
            }
    
            if (!form.checkValidity()) {
                form.classList.add('was-validated')
                return false
            }
    
            if (form.checkValidity()) {
                // Evita reenvio (ex.: Enter no teclado) enquanto a requisição está em andamento
                if (form.disabled === true) {
                    return false;
                }

                let formData = new FormData(form);
                if (images.length > 0) {
                    fields.forEach(obj => {
                        if (!obj.value) obj.value = '';
                        formData.append(obj.name, obj.value);
                    });
                }

                let type = 'POST';
                let url = form.action;
                let dataType = 'json';

                const modalSuccess = document.getElementById('success-message-forms');
                const modalSuccessDescription = document.querySelector('#success-message-forms .description');
                const modalError = document.getElementById('error-message-forms');
                const modalDescription = document.querySelector('#error-message-forms .description');
                const Loader = document.getElementById("loading-forms");

                const submitButton = form.querySelector('[type="submit"]');
                // O POST só sai depois do token do reCAPTCHA voltar, então trava
                // o botão de fato — não dá pra contar só com o overlay do loader.
                const releaseForm = () => {
                    Loader.classList.remove("open-modal");
                    form.disabled = false;
                    if (submitButton) submitButton.disabled = false;
                };

                Loader.classList.add("open-modal");
                form.disabled = true;
                if (submitButton) submitButton.disabled = true;
                class Form extends AjaxClass {
                    successFunction(data, form) {
                        if (data.status === true) {
                            if (window.dataLayer && Array.isArray(window.dataLayer) && e.target.id === 'simulation-form-2') {
                                dataLayer.push({
                                    event: 'gtm.formSubmit',
                                    formName: 'Simulação Etapa 2'
                                });
                            }
                            if (window.dataLayer && Array.isArray(window.dataLayer) && e.target.id === 'seja-franqueado') {
                                dataLayer.push({
                                    event: 'gtm.formSubmit',
                                    formName: 'Seja um Franqueado'
                                });
                            }
                            if (window.dataLayer && Array.isArray(window.dataLayer) && e.target.id === 'formulario-unidade') {
                                dataLayer.push({
                                    event: 'gtm.formSubmit',
                                    formName: 'Formulário Unidade'
                                });
                            }
                            if (window.dataLayer && Array.isArray(window.dataLayer) && e.target.id === 'formulario-simulacao-unidade-etapa-2') {
                                const queryString = window.location.search;
                                const urlParams = new URLSearchParams(queryString);
                                let unidade = urlParams.get('unidade');                                
                                let unidadeSlugAmigavel = unidade.toLowerCase().replace(/\s+/g, '_');
                                console.log('disparo do evento gtm.simulacao_etapa_2_unidade_lp_' + unidadeSlugAmigavel);
                                
                                dataLayer.push({
                                    event: 'gtm.simulacao_etapa_2_unidade_lp_' + unidadeSlugAmigavel,
                                    formName: 'Simulação Unidade LP',
                                    unidade: unidade
                                });
                            }
                            if (data.redirect) {
                                // Segue travado até a navegação concluir: liberar aqui
                                // deixa o form clicável durante o carregamento da página.
                                window.location = data.redirect;
                                return;
                            }

                            // Precisa ler antes do reset() — o reset já devolve o campo
                            // pro valor padrão da página, então lido depois viria vazio
                            // (ou com o valor antigo da sessão, não o que foi digitado).
                            const typedEmail = form.querySelector('[name="email"]')?.value.trim() || '';
                            const typedPhone = form.querySelector('[name="phone"]')?.value.trim() || '';

                            form.reset();
                            releaseForm();

                            // Se for versão B (beta), abrimos o pop-up de escolha de canal
                            // (E-mail/WhatsApp) em vez do modal de sucesso genérico.
                            if (data.is_beta) {
                                if (SIMULATION_STEP_TWO_FORM_IDS.includes(form.id)) {
                                    conversionPopup.open(data.simulationId, typedEmail, typedPhone);
                                    return;
                                }

                                modalSuccess.classList.add("open-modal");
                                // Ajusta mensagem conforme canal de contato
                                if (data.contact_method === 'whatsapp' && data.whatsapp_url) {
                                    modalSuccessDescription.innerHTML = data.txt + '<br><small>Você será redirecionado para o WhatsApp em uma nova aba.</small>';
                                    // abre WhatsApp em nova aba imediatamente
                                    try { window.open(data.whatsapp_url, '_blank'); } catch (err) { console.warn('Não foi possível abrir WhatsApp:', err); }
                                } else if (data.contact_method === 'email') {
                                    modalSuccessDescription.innerHTML = data.txt + '<br><small>Verifique seu e-mail.</small>';
                                } else {
                                    modalSuccessDescription.innerHTML = data.txt;
                                }

                                // Após o usuário confirmar o modal, redireciona para a página de agradecimento
                                const confirmBtn = modalSuccess.querySelector('.confirm');
                                if (confirmBtn && data.contact_success_redirect) {
                                    const handler = function () {
                                        window.location = data.contact_success_redirect;
                                        confirmBtn.removeEventListener('click', handler);
                                    };
                                    confirmBtn.addEventListener('click', handler);
                                }
                                return;
                            }

                            modalSuccess.classList.add("open-modal");
                            modalSuccessDescription.innerHTML = data.txt;
                            return;
                        }

                        releaseForm();
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                    }

                    errorFunction(xhr, textStatus, errorThrown) {
                        releaseForm();
                        modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";

                        if (errorThrown === 'Too Many Requests' || xhr.responseText === 'Too Many Requests') {
                            modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                        }

                        modalError.classList.add("open-modal");
                    }
                }
    
                let ajax = new Form(form, type, url, dataType, formData);
                ajax.send();
            }
    
            return false;
        });
    });
    
    document.querySelectorAll('[phone]').forEach(phoneElement => {
        phoneElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
    
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode) || (charCode === 190 && !this.value.includes('.'))) {
                return;
            }
    
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        phoneElement.addEventListener('blur', function () {
            mascaraDeTelefone(this);
        });
    
        phoneElement.addEventListener('focus', function () {
            tiraHifen(this);
        });
    });
    
    function mascaraDeTelefone(telefone) {
        let textoAtual = telefone.value.replace(/[^0-9]/g, '');
        if (textoAtual.length >= 12 && textoAtual.startsWith('55')) {
            textoAtual = textoAtual.slice(2);
        }
        textoAtual = textoAtual.replace(/^0+/, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
    
        if (isCelular) {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 7);
            const parte3 = textoAtual.slice(7, 11);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        } else {
            const parte1 = textoAtual.slice(0, 2);
            const parte2 = textoAtual.slice(2, 6);
            const parte3 = textoAtual.slice(6, 10);
    
            textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
        }
    
        telefone.value = textoAjustado || null;
    }
    
    function tiraHifen(telefone) {
        telefone.value = telefone.value.replace(/\./g, '');
    }
    
    document.querySelectorAll('[cnpj]').forEach(cnpjElement => {
        cnpjElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cnpjElement.addEventListener('blur', function () {
            aplicarMascaraCNPJ(this);
        });
    
        cnpjElement.addEventListener('focus', function () {
            removerMascaraCNPJ(this);
        });
    });
    
    function aplicarMascaraCNPJ(cnpj) {
        const textoAtual = cnpj.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 2);
        const parte2 = textoAtual.slice(2, 5);
        const parte3 = textoAtual.slice(5, 8);
        const parte4 = textoAtual.slice(8, 12);
        const parte5 = textoAtual.slice(12, 14);
        
        cnpj.value = `${parte1}.${parte2}.${parte3}/${parte4}-${parte5}`; 
    }
    
    function removerMascaraCNPJ(cnpj) {
        cnpj.value = cnpj.value.replace(/[^0-9]/g, '');
    }

    document.querySelectorAll('[cpf]').forEach(cpfElement => {
        cpfElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            // Bloquear qualquer caractere que não seja número
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });

        cpfElement.addEventListener('blur', function () {
            aplicarMascaraCPF(this);
        });

        cpfElement.addEventListener('focus', function () {
            removerMascaraCPF(this);
        });
    });

    function aplicarMascaraCPF(cpf) {
        const textoAtual = cpf.value.replace(/[^0-9]/g, '');

        const parte1 = textoAtual.slice(0, 3);
        const parte2 = textoAtual.slice(3, 6);
        const parte3 = textoAtual.slice(6, 9);
        const parte4 = textoAtual.slice(9, 11);

        // Formato: 000.000.000-00
        cpf.value = `${parte1}${parte2 ? '.' + parte2 : ''}${parte3 ? '.' + parte3 : ''}${parte4 ? '-' + parte4 : ''}`;
    }

    function removerMascaraCPF(cpf) {
        cpf.value = cpf.value.replace(/[^0-9]/g, '');
    }


    document.querySelectorAll('[cep]').forEach(cepElement => {
        cepElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            
            // Permite teclas como backspace, delete, tab, enter e setas
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }
            
            // Restringe entrada apenas a números
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        });
    
        cepElement.addEventListener('blur', function () {
            aplicarMascaraCEP(this);
        });
    
        cepElement.addEventListener('focus', function () {
            removerMascaraCEP(this);
        });
    });
    
    function aplicarMascaraCEP(cep) {
        const textoAtual = cep.value.replace(/[^0-9]/g, '');
        
        const parte1 = textoAtual.slice(0, 5);
        const parte2 = textoAtual.slice(5, 8);
        
        cep.value = `${parte1}-${parte2}`;
    }
    
    function removerMascaraCEP(cep) {
        cep.value = cep.value.replace(/[^0-9]/g, '');
    }
    
    document.querySelectorAll('[documento]').forEach(docElement => {
        docElement.addEventListener('keypress', function (event) {
            const charCode = event.which || event.keyCode;
            const char = String.fromCharCode(charCode);

            // Permitir teclas de controle
            if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
                return;
            }

            const valorAtual = this.value.replace(/[^a-zA-Z0-9]/g, '');

            // Já possui alguma letra?
            const ehCnpjAlfanumerico = /[A-Za-z]/.test(valorAtual);

            if (ehCnpjAlfanumerico) {
                // CNPJ alfanumérico
                if (!/[A-Za-z0-9]/.test(char)) {
                    event.preventDefault();
                }
            } else {
                // Ainda pode ser CPF ou CNPJ numérico
                if (!/[0-9A-Za-z]/.test(char)) {
                    event.preventDefault();
                }
            }
        });

        docElement.addEventListener('blur', function () {
            aplicarMascaraDocumento(this);
        });

        docElement.addEventListener('focus', function () {
            removerMascaraDocumento(this);
        });

        docElement.addEventListener('input', function () {
            this.value = this.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        });
    });

    function aplicarMascaraDocumento(el) {

        const texto = el.value
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase();

        // CPF = somente números e até 11 dígitos
        const ehCpf = /^\d{1,11}$/.test(texto);

        if (ehCpf) {

            // CPF: 000.000.000-00
            const parte1 = texto.slice(0, 3);
            const parte2 = texto.slice(3, 6);
            const parte3 = texto.slice(6, 9);
            const parte4 = texto.slice(9, 11);

            el.value =
                `${parte1}` +
                `${parte2 ? '.' + parte2 : ''}` +
                `${parte3 ? '.' + parte3 : ''}` +
                `${parte4 ? '-' + parte4 : ''}`;

        } else {

            // CNPJ (numérico ou alfanumérico): XX.XXX.XXX/XXXX-XX
            const parte1 = texto.slice(0, 2);
            const parte2 = texto.slice(2, 5);
            const parte3 = texto.slice(5, 8);
            const parte4 = texto.slice(8, 12);
            const parte5 = texto.slice(12, 14);

            el.value =
                `${parte1}` +
                `${parte2 ? '.' + parte2 : ''}` +
                `${parte3 ? '.' + parte3 : ''}` +
                `${parte4 ? '/' + parte4 : ''}` +
                `${parte5 ? '-' + parte5 : ''}`;
        }
    }

    function removerMascaraDocumento(el) {
        el.value = el.value.replace(/[^a-zA-Z0-9]/g, '');
    }

}